export default __webpack_public_path__ + "static/stackswap-54e35a29060913d116c39a53d6f29370.svg";